import DOMPurify from "dompurify";
export const sanitizeHtmlDescription = (html) => {
    const sanitizedHtml = DOMPurify.sanitize(html, {
        USE_PROFILES: { html: true },
        FORBID_TAGS: ["mark", "script"],
    });
    return sanitizedHtml;
};
export default sanitizeHtmlDescription;
//# sourceMappingURL=sanitizeHtmlDescription.js.map